import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  Title,
  Center,
  Grid,
  List,
  Stack,
  TypographyStylesProvider,
  useMantineTheme,
} from '@mantine/core';

import * as classes from './FeatureCompare.module.css';
import ButtonBlock from '../ButtonBlock';


function FeatureCompare({
  featuresSottotitolo,
  featuresTitolo,
  featuresButtons,
  featuresList,
  stile,
}) {
  const { colors, white } = useMantineTheme();

  return (
    <Container className={classes.wrapper} fluid style={{ backgroundColor: stile?.coloreDiSfondo ? colors[stile?.coloreDiSfondo][1] : 'inherit' }}>
      <Container>
        {featuresTitolo && (
          <Title order={2} size="h1" className={classes.title} ta="center" mt="sm">
            {featuresTitolo}
          </Title>
        )}

        {featuresSottotitolo && (
          <Container>
            <TypographyStylesProvider className={classes.description}>
              <div
                dangerouslySetInnerHTML={{ __html: featuresSottotitolo }}
              />
            </TypographyStylesProvider>
          </Container>
        )}

        <Grid
          grow
          mt={60}
          className={classes.gridBlock}
        >
          {featuresList.map(({
            bloccoCompareSingleFeatures,
            bloccoCompareSingleTitle,
            bloccoCompareSingleButton,
            stile: st,
          }, key) => {

            return (
              <Grid.Col
                span={4}
                className={classes.gridCol}
                key={`feat_${key + 1}`}
              >
                <Stack
                  className={classes.gridBlockContainer}
                  p="md"
                  justify="space-between"
                  style={{
                    backgroundColor: colors[st?.coloreDiSfondo] ? colors[st?.coloreDiSfondo][1] : white,
                    border: `1px solid ${colors[st?.coloreDiSfondo] ? colors[st?.coloreDiSfondo][2] : white}`,
                  }}
                >
                  <Title ta="center" order={3}>{bloccoCompareSingleTitle}</Title>

                  <List mt="md" className={classes.gridList}>
                    {bloccoCompareSingleFeatures.map(({ bloccoFeatureDescrizione, bloccoFeatureTitolo }, kk) => (
                      <List.Item key={`item_${kk}`} style={{ color: colors.dark[5] }}>
                        {bloccoFeatureTitolo}
                        {bloccoFeatureDescrizione && bloccoFeatureTitolo && <>&nbsp;-&nbsp;</>}
                        {bloccoFeatureDescrizione}
                      </List.Item>
                    ))}
                  </List>
                  {!!bloccoCompareSingleButton?.length && (
                    <Center>
                      <ButtonBlock buttons={bloccoCompareSingleButton} />
                    </Center>
                  )}
                </Stack>
              </Grid.Col>
            );
          })}

        </Grid>
        {!!featuresButtons?.length && (
          <Center mt="md" mb="xl">
            <ButtonBlock buttons={featuresButtons} />
          </Center>
        )}
      </Container>
    </Container>
  );
}

FeatureCompare.propTypes = {
  featuresTitolo: PropTypes.string,
  featuresSottotitolo: PropTypes.string,
  featuresButtons: PropTypes.array,
  featuresList: PropTypes.array,
};

export default FeatureCompare;
